import { createBitAttrs, getOptionUpdater, removeUndefined } from "../../internal/index.js";
import { createAvatar } from "@melt-ui/svelte";
import { getContext, setContext } from "svelte";
const NAME = "avatar";
const PARTS = ["root", "image", "fallback"];
export const getAttrs = createBitAttrs(NAME, PARTS);
export function setCtx(props) {
    const avatar = createAvatar(removeUndefined(props));
    setContext(NAME, avatar);
    return {
        ...avatar,
        updateOption: getOptionUpdater(avatar.options)
    };
}
export function getImage(src = "") {
    const avatar = getContext(NAME);
    if (!src) {
        avatar.options.src.set("");
    }
    else {
        avatar.options.src.set(src);
    }
    return avatar;
}
export function getCtx() {
    return getContext(NAME);
}
